import { validateUrlWithOptionalProtocol } from './validateUrlWithOptionalProtocol';

export const validateOptionalUrlWithOptionalProtocol = (
  value: string | undefined,
): boolean => {
  if (value === undefined || value === '') {
    return true;
  }

  return validateUrlWithOptionalProtocol(value);
};
